import { RatingResponse } from "@/data/dtos/responses";
import {
  CreateCallRatingInput,
  UpdateCallRatingInput,
} from "@/domain/dtos/inputs";
import { RatingDataSource } from "./RatingDataSource";
import { ApiService } from "@/domain/clients";
import { Endpoints } from "@/infra/api";

export class RatingRemoteDataSource implements RatingDataSource {
  constructor(private readonly api: ApiService) {}

  async createCallRating(params: CreateCallRatingInput): Promise<unknown> {
    return this.api.post<RatingResponse, CreateCallRatingInput>(
      Endpoints.call_rating,
      params,
    );
  }

  async getCallRatings(filters: {
    psychologist_id?: number;
    page?: number;
  }): Promise<RatingResponse[]> {
    const { data } = await this.api.get<RatingResponse[]>(
      Endpoints.call_rating,
      filters,
    );

    if (!data) {
      return [];
    }

    return data;
  }

  async updateCallRating(
    id: number,
    params: UpdateCallRatingInput,
  ): Promise<unknown> {
    return this.api.put<RatingResponse, UpdateCallRatingInput>(
      `${Endpoints.call_rating}/${id}`,
      params,
    );
  }

  async removeCallRating(id: number): Promise<{ message: string }> {
    const { message } = await this.api.delete(`${Endpoints.call_rating}/${id}`);

    return {
      message: message || "O depoimento foi removido e não está mais visível.",
    };
  }
}
